import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { BorderRadiusProps, MinHeightProps, MinWidthProps } from 'styled-system';
import {
  alignItems,
  backgroundColor,
  borderRadius,
  height,
  justifyContent,
  minHeight,
  minWidth,
  position,
  right,
  top,
  width,
} from 'styled-system';

import { Button } from 'common/components/Button';
import Icon from 'common/components/Icon';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { BackgroundColorProps } from 'common/theme/system-types';

const ICON_SIZE = 32;
const BUTTON_SIZE = 40;

const StyledButton = styled(Button)`
  ${position};
  ${top};
  ${right};
  ${height};
  ${width};
  ${alignItems};
  ${justifyContent};
  ${borderRadius};

  &:focus-visible {
    outline-offset: -2px;
  }
`;

const buttonStyles = {
  position: 'absolute',
  top: '4px',
  right: '4px',
  height: BUTTON_SIZE,
  width: BUTTON_SIZE,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 'circle',
};

const CloseIcon = styled(Icon)<
  MinHeightProps & MinWidthProps & BackgroundColorProps & BorderRadiusProps
>`
  ${minHeight};
  ${minWidth};
  ${backgroundColor};
  ${borderRadius}
`;

const iconStyles: Partial<ComponentProps<typeof CloseIcon>> = {
  size: ICON_SIZE,
  minHeight: ICON_SIZE,
  minWidth: ICON_SIZE,
  backgroundColor: 'sys.neutral.background.default',
  borderRadius: 'x-large',
};

const CloseButton = (props: ComponentProps<typeof StyledButton>) => {
  const { t } = useLocalization();

  return (
    <StyledButton kind="bare" {...buttonStyles} {...props}>
      <CloseIcon name="close" {...iconStyles} ariaLabel={t('h24_close_birthday_card')} />
    </StyledButton>
  );
};

export default CloseButton;
